import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { Field } from '@alfa-bank/site-form-utils/components/form-field';
import { PhoneInput } from '@alfa-bank/site-input/phone-input-v2';
import { getCaption } from '@alfa-bank/site-helpers-form/meta/get-caption';
import { isError } from '@alfa-bank/site-helpers-form/meta/is-error';
import { isSuccess } from '@alfa-bank/site-helpers-form/meta/is-success';
import { Phone as Component } from '@alfa-bank/site-form-phone/src/form-phone';

import type { IDepsCommonPhoneInput, TX5BankPhoneInput } from './models';

export const CommonPhoneInput = createWidget<IDepsCommonPhoneInput, TX5BankPhoneInput>({
    Field,
    PhoneInput,
    isSuccess,
    isError,
    getCaption,
})(Component);
